// 参考自 https://github.com/AnnaSearl/anna-remax-ui/blob/master/components/loading

/**
 * loading
 * 用于页面和区块的加载中状态
 */

import React, { CSSProperties } from 'react';
import { View } from '@tarojs/components';

interface ILoadingProps {
  style?: CSSProperties;
  className?: string;
  color?: string;
}

export default ({ style = {}, className = '', color }: ILoadingProps) => {
  const lineStyle = color ? { backgroundColor: color } : {};
  return (
    <View style={style} className={`ace-loading ${className}`}>
      <View className="ace-loading-content">
        <View className="ace-loading-line" style={lineStyle} />
        <View className="ace-loading-line" style={lineStyle} />
        <View className="ace-loading-line" style={lineStyle} />
        <View className="ace-loading-line" style={lineStyle} />
      </View>
    </View>
  );
};
